import { createSlice } from "@reduxjs/toolkit";
import { getNonRealReportList, getReportList } from "./_reportAction";


interface ManageReportState {
  reportList: any[];
  loading: boolean;
  error: string | null;
  totalCount: number
}

const initialState: ManageReportState = {
  reportList: [],
  loading: false,
  error: null,
  totalCount: 0
};


export const reportReducer = createSlice({
  name: "report",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Report
      .addCase(getReportList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getReportList.fulfilled, (state, action) => {
        state.loading = false;
        state.reportList = action.payload?.data;
        state.totalCount = action.payload?.count;
      })
      .addCase(getReportList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Non Real Report
      .addCase(getNonRealReportList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNonRealReportList.fulfilled, (state, action) => {
        state.loading = false;
        state.reportList = action.payload?.data;
        state.totalCount = action.payload?.count;
      })
      .addCase(getNonRealReportList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

  },
});


export const { clearError } = reportReducer.actions;
export default reportReducer;